import { Component, Input } from '@angular/core';

// "★ 4.4" style rating display with auto-coloured tone.
@Component({
  selector: 'tangram-analytics-rating-value',
  template: `<span class="rating-value"
                   *ngIf="rating > 0; else empty"
                   [class.rating--top]="effectiveTone === 'top'"
                   [class.rating--mid]="effectiveTone === 'mid'"
                   [class.rating--low]="effectiveTone === 'low'">
               <svg class="rating-star" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                 <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
               </svg>
               {{ rating | number:'1.1-1' }}
             </span>
             <ng-template #empty><span class="muted-text">No data</span></ng-template>`,
  styleUrls: ['./analytics-rating-value.component.scss']
})
export class AnalyticsRatingValueComponent {
  @Input() rating = 0;
  @Input() forceTone: 'top' | 'mid' | 'low' | null = null;

  get effectiveTone(): 'top' | 'mid' | 'low' {
    if (this.forceTone) { return this.forceTone; }
    if (this.rating >= 4) { return 'top'; }
    if (this.rating >= 3) { return 'mid'; }
    return 'low';
  }
}
